import React from "react";
import { DeviceOnboardingTemplate } from "themes/application/device-settings/components";

function DeviceOnboarding(props) {
    return <DeviceOnboardingTemplate {...props} />;
}

export default DeviceOnboarding;
